import { constants } from "redux/constants/redux-constants";

const initialState = {
  code: "",
  label: "",
  value: "",
};

const conversationalLanguageReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.SET_CONVERSATIONAL_LANGAUGE:
      return {
        ...state,
        code: action.payload.code,
        label: action.payload.label,
        value: action.payload.value,
      };
    default:
      return state;
  }
};

export default conversationalLanguageReducer;
